// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual-keyboard-floating {
  position: fixed;
  z-index: 1200;
  width: min(520px, calc(100vw - 16px));
}

.virtual-keyboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid #d1d5db;
  border-bottom: none;
  border-radius: 20px 20px 0 0;
  background: #f8fafc;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.virtual-keyboard-title-group {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.virtual-keyboard-title {
  font-size: 0.92rem;
  font-weight: 600;
  color: #111827;
}

.virtual-keyboard-layout {
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  background: #e5e7eb;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.virtual-keyboard-close {
  width: 32px;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: var(--surface-color);
  color: #6b7280;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
}

.virtual-keyboard-panel {
  padding: 0.9rem;
  border: 1px solid #d1d5db;
  border-top: none;
  border-radius: 0 0 20px 20px;
  background: var(--surface-color);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.dark .virtual-keyboard-header,
.dark .virtual-keyboard-panel {
  background: #1f2937;
  border-color: #374151;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.dark .virtual-keyboard-title {
  color: #f9fafb;
}

.dark .virtual-keyboard-layout {
  background: #374151;
  color: #d1d5db;
}

.dark .virtual-keyboard-close {
  background: #374151;
  border-color: #4b5563;
  color: #d1d5db;
}

.virtual-keyboard-rows {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.virtual-keyboard-row {
  display: flex;
  justify-content: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.virtual-keyboard-key {
  min-width: 42px;
  height: 40px;
  padding: 0 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 14px;
  background: #f8fafc;
  color: #1f2937;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.virtual-keyboard-key:hover {
  background: #eef2f7;
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.dark .virtual-keyboard-key {
  background: #374151;
  color: #f9fafb;
  border-color: #4b5563;
}

.dark .virtual-keyboard-key:hover {
  background: #4b5563;
  border-color: #6b7280;
}

.virtual-keyboard-key--action {
  min-width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/VirtualKeyboard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".virtual-keyboard-floating {\n  position: fixed;\n  z-index: 1200;\n  width: min(520px, calc(100vw - 16px));\n}\n\n.virtual-keyboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.75rem 0.9rem;\n  border: 1px solid #d1d5db;\n  border-bottom: none;\n  border-radius: 20px 20px 0 0;\n  background: #f8fafc;\n  cursor: grab;\n  user-select: none;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.virtual-keyboard-title-group {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.virtual-keyboard-title {\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.virtual-keyboard-layout {\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  background: #e5e7eb;\n  color: #475569;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.virtual-keyboard-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  background: var(--surface-color);\n  color: #6b7280;\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.virtual-keyboard-panel {\n  padding: 0.9rem;\n  border: 1px solid #d1d5db;\n  border-top: none;\n  border-radius: 0 0 20px 20px;\n  background: var(--surface-color);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.dark .virtual-keyboard-header,\n.dark .virtual-keyboard-panel {\n  background: #1f2937;\n  border-color: #374151;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);\n}\n\n.dark .virtual-keyboard-title {\n  color: #f9fafb;\n}\n\n.dark .virtual-keyboard-layout {\n  background: #374151;\n  color: #d1d5db;\n}\n\n.dark .virtual-keyboard-close {\n  background: #374151;\n  border-color: #4b5563;\n  color: #d1d5db;\n}\n\n.virtual-keyboard-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.virtual-keyboard-row {\n  display: flex;\n  justify-content: center;\n  gap: 0.45rem;\n  flex-wrap: wrap;\n}\n\n.virtual-keyboard-key {\n  min-width: 42px;\n  height: 40px;\n  padding: 0 0.8rem;\n  border: 1px solid #d1d5db;\n  border-radius: 14px;\n  background: #f8fafc;\n  color: #1f2937;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.virtual-keyboard-key:hover {\n  background: #eef2f7;\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.dark .virtual-keyboard-key {\n  background: #374151;\n  color: #f9fafb;\n  border-color: #4b5563;\n}\n\n.dark .virtual-keyboard-key:hover {\n  background: #4b5563;\n  border-color: #6b7280;\n}\n\n.virtual-keyboard-key--action {\n  min-width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
